var React = require('react');

function Coordinates (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"SYMBOLS","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"uti/icon/illustration/map","stroke":"#4F4F4F"},React.createElement("path",{"d":"M12,21.5 C10.4801025,21.5 4,14.418278 4,10 C4,5.581722 7.581722,2 12,2 C16.418278,2 20,5.581722 20,10 C20,14.418278 13.5198975,21.5 12,21.5 Z M12,13 C13.6568542,13 15,11.6568542 15,10 C15,8.34314575 13.6568542,7 12,7 C10.3431458,7 9,8.34314575 9,10 C9,11.6568542 10.3431458,13 12,13 Z","id":"Combined-Shape"}))));
}

Coordinates.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Coordinates;

Coordinates.default = Coordinates;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/coordinates.svg
// module id = 1469
// module chunks = 0